<div class="wizard position-relative flex-grow-1 d-flex flex-column">
  @switch (step()) {
    @case ('step1') {
      <app-step1
        (animate.enter)="animate($event, direction() === 'back' ? 'wizard-back-enter' : '')"
        (animate.leave)="animate($event, 'wizard-forward-leave')"
        (next)="onNext()"
      />
    }
    @case ('step2') {
      @if (data(); as lists) {
        <app-step2
          [countries]="lists.countries"
          [timeZones]="lists.timeZones"
          [currencies]="lists.currencies"
          (animate.enter)="animate($event, 'wizard-forward-enter')"
          (animate.leave)="animate($event, direction() === 'back' ? 'wizard-back-leave' : 'wizard-forward-leave')"
          (back)="onBack()"
          (submitted)="onSubmitted($event)"
        />
      } @else {
        <div class="loader"></div>
      }
    }
    @case ('thankyou') {
      <app-thankyou (animate.enter)="animate($event, 'wizard-forward-enter')" />
    }
  }
</div>
